import { UserStatus } from '@core/generated/gql-types';

export const STATUS_OPTIONS = [
  {
    value: UserStatus.Active,
    label: 'Approved',
    color: 'bg-green-100 text-green-800',
    dotColor: 'bg-green-500',
  },
  {
    value: UserStatus.Pending,
    label: 'Onboarding',
    color: 'bg-yellow-100 text-yellow-800',
    dotColor: 'bg-yellow-500',
  },
  {
    value: UserStatus.PendingReview,
    label: 'Pending',
    color: 'bg-orange-100 text-orange-800',
    dotColor: 'bg-orange-500',
  },
  {
    value: UserStatus.OnHold,
    label: 'On hold',
    color: 'bg-gray-100 text-gray-600',
    dotColor: 'bg-gray-400',
  },
  {
    value: UserStatus.DocsExpired,
    label: 'Docs expired',
    color: 'bg-red-100 text-red-800',
    dotColor: 'bg-red-500',
  },
  {
    value: UserStatus.Suspended,
    label: 'Suspended',
    color: 'bg-red-100 text-red-800',
    dotColor: 'bg-red-500',
  },
  {
    value: UserStatus.Deleted,
    label: 'Archived',
    color: 'bg-gray-100 text-gray-600',
    dotColor: 'bg-gray-400',
  },
];

export const getStatusDisplay = (status: UserStatus | string) => {
  const option = STATUS_OPTIONS.find((opt) => opt.value === status);
  return (
    option || {
      value: status,
      label: status,
      color: 'bg-gray-100 text-gray-800',
      dotColor: 'bg-gray-400',
    }
  );
};
